import { axiosInstance } from "../../axios";
import { parseError } from "../../filters/validationmessage"


const POSTGetVisitHistoryCount = "api/VisitHistoryByLocation/SearchVisitHistoryCount"
const POSTGetVisitHistoryByLocation = "api/VisitHistoryByLocation/VisitHistoryCountByLocation"


const searchVisitHistoryCount = async function(payload) {
    try {
      const response = await axiosInstance.reportAPIInstance.post(POSTGetVisitHistoryCount, payload);
      return parseList(response);
    } catch (error) {
        return null;
    }
  };

  const searchVisitHistoryByLocation = async function(payload) {
    try {
      const response = await axiosInstance.reportAPIInstance.post(POSTGetVisitHistoryByLocation, payload);
      return parseList(response);
    } catch (error) {
        return null;
    }
  };

  const parseList = response => {
    if (response.status !== 200) throw Error(response.message);
    if (!response.data) return [];
    let list = response.data;
    if (typeof list !== "object") {
      list = [];
    }
    return list;
  };


  export const visitHistoryData = {
    searchVisitHistoryCount,
    searchVisitHistoryByLocation
  };
  
  